import {
  BarisResepTerstruktur,
  RacikanTerstruktur,
  barisDariItemResep,
  racikanDariResep
} from "@/utils/resepTerstruktur";

export interface ItemTemplateResep {
  obat_id: string;
  obat_nama: string | null;
  qty: number | null;
  qty_unit: string | null;
  harga?: number | string | null;
  ap_dosis?: string | null;
  ap_tambahan?: string | null;
  frekuensi_id: number | null;
  frekuensi?: { id: number; nama: string } | null;
  rute_id: number | null;
  rute?: { id: number; nama: string } | null;
  dosis_qty?: number | null;
  satuan_dosis_id?: number | null;
  signa_bebas?: string | null;
  aturan_tambahan_ids?: number[];
  r: string | null;
}

export interface RacikanTemplateResep {
  r: string;
  nama: string | null;
  sediaan_id: number | null;
  qty: number | null;
  frekuensi_id: number | null;
  signa_bebas: string | null;
  rute_id: number | null;
  ap_dosis: string | null;
  dosis_qty: number | null;
  satuan_dosis_id: number | null;
  aturan_tambahan_ids: number[];
  bud_hari: number | null;
  items: ItemTemplateResep[];
}

export interface TemplateResep {
  id: number;
  nama: string;
  text: string | null;
  user_id: number;
  items: ItemTemplateResep[];
  racikan?: RacikanTemplateResep[];
}

function bukanRacikan(item: ItemTemplateResep): boolean {
  return !item.r;
}

export function itemTemplateRanap(template: TemplateResep): any[] {
  const racikan = template.racikan || [];

  if (racikan.length === 0) {
    return [...(template.items || [])];
  }

  const tunggal = (template.items || [])
    .filter(bukanRacikan)
    .map(item => ({ ...item, type: "nrc", r: "" }));

  const kelompok = racikan.map(header => ({
    type: "rc",
    obat_nama: null,
    nama: header.nama,
    qty: header.qty,
    qty_unit: null,
    harga: null,
    countedHarga: null,
    obat_id: null,
    ap_rute: null,
    ap_frekuensi: null,
    ap_dosis: header.ap_dosis,
    ap_tambahan: null,
    ap_template_id: null,
    ap_template_nama: null,
    r: header.r,
    frekuensi_id: header.frekuensi_id,
    rute_id: header.rute_id,
    sediaan_id: header.sediaan_id,
    items: (header.items || []).map(item => ({ ...item, r: header.r }))
  }));

  return [...tunggal, ...kelompok];
}

export function barisDariTemplate(
  template: TemplateResep
): BarisResepTerstruktur[] {
  return (template.items || [])
    .filter(bukanRacikan)
    .map(item => barisDariItemResep({ ...item, id: null }));
}

export function racikanDariTemplate(
  template: TemplateResep
): RacikanTerstruktur[] {
  return (template.racikan || []).map(header =>
    racikanDariResep({
      ...header,
      id: null,
      items: (header.items || []).map(item => ({ ...item, id: null }))
    })
  );
}

export function ringkasTemplate(template: TemplateResep): string {
  const nama = (template.items || [])
    .filter(bukanRacikan)
    .map(item => item.obat_nama || item.obat_id);
  const racikan = (template.racikan || []).map(r => r.nama || "Racikan");
  const semua = [...nama, ...racikan];

  if (semua.length === 0) {
    return template.text || "—";
  }

  return (
    semua.slice(0, 3).join(", ") +
    (semua.length > 3 ? `, +${semua.length - 3} lainnya` : "")
  );
}
